<script setup lang="ts">

import type NewsItem from "@/types/NewsItem.ts";
import NewsItemBase from '@/components/Sections/News/Types/Base/NewsItemBase.vue'
import NewsItemBaseStructure from '@/components/Sections/News/Types/Base/NewsItemBaseStructure.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const gameStore = useGameStore();

const props = defineProps<{
  newsItem: NewsItem,
  toast: boolean
}>();

</script>

<template>
  <NewsItemBase
    :toast="toast"
    :toast-image="gameStore.cdnUrl + 'images/map/blackhole.webp'"
    :toast-text="t('news.types.shipsLostBlackHole.toast', { count: props.newsItem.contentData.ships })"
  >
    <NewsItemBaseStructure
      :newsItem="props.newsItem"
      :item-image="gameStore.cdnUrl + 'images/map/blackhole.webp'"
      :header="t('news.types.shipsLostBlackHole.title')"
    >
      {{ t('news.types.shipsLostBlackHole.body', { count: props.newsItem.contentData.ships }) }}<br>
    </NewsItemBaseStructure>
  </NewsItemBase>
</template>

<style scoped lang="scss">

</style>